import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { MAX_PAGE_SIZE } from '@cbridge-utils/datagrid';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolLpTranslator } from '@cbridge-packages/symbol-lp';
import { fetchUnmappedSymbolsLpRecursively } from '../_operators/fetchUnmappedSymbolsLpRecursively';
import { SymbolLpAction } from '../symbolLp.action';

type IDependencies = IClientApiDependencySegment;

export const loadUnmappedSymbolsEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolLpAction.loadUnmapped.started),
  switchMap((params) => {
    const { lpId, search } = params;
    return fetchUnmappedSymbolsLpRecursively(
      lpId,
      { skip: 0, limit: MAX_PAGE_SIZE, search },
      dependencies,
    ).pipe(
      mergeMap((lpSymbols) => {
        const result = lpSymbols.map(SymbolLpTranslator.fromApiUnmapped);

        return [
          SymbolLpAction.loadUnmapped.done({ params, result }),
        ];
      }),
      catchApiError((error) => {
        return [
          SymbolLpAction.loadUnmapped.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
